export const LEGAL_PRODUCT_SERVICE_SPECIFICS: string = `

### <!--= ++sectionIndex -->. Produkt-/Dienstleistungsspezifika
<!-- subSectionIndex = 0; -->

<!-- for (const productTerm of termsOfUse.productTerms) { -->
#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. <!--= productTerm.heading -->

<!-- for (const textLine of productTerm.texts) { -->
<!--= textLine -->

<!-- } -->

<!-- } -->
`;
